import { render, staticRenderFns } from "./OutClinicInvoice.vue?vue&type=template&id=36e16746&scoped=true"
import script from "./OutClinicInvoice.vue?vue&type=script&lang=js"
export * from "./OutClinicInvoice.vue?vue&type=script&lang=js"
import style0 from "./OutClinicInvoice.vue?vue&type=style&index=0&id=36e16746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e16746",
  null
  
)

export default component.exports